import { FC } from "react";
import explosionIMG from "../assets/explosion.gif";
import Style from "./Style.module.scss";

type ExplotionProps = {
  position?: React.CSSProperties;
};

const Explotion: FC<ExplotionProps> = ({ position }) => {
  return (
    <img
      style={{ ...position }}
      className={Style.explosionTransition}
      width={50}
      height={50}
      src={explosionIMG}
      alt='explosion'
    />
  );
};

export default Explotion;
